// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"eec683d2","54":"ec3d4347","166":"7b15ed17","232":"a43f9833","260":"b9bf9832","545":"6d68bcca","573":"8a05358f","730":"b48a090c","838":"04fbd27b","851":"bf612ae9","890":"537c1a90","958":"9df9acc0","990":"996b2607"}[chunkId] + ".chunk.js";
};